import initMobileMenu from './mobileMenu';
import initScrollToTop from './scrollToTop';

export default function () {
    initMobileMenu();
    initScrollToTop();
}


// WEBPACK FOOTER //
// ./uPortal/Core/Shared/Navigation/Js/index.js